/**
 * Accordion section — theme trigger, accordion toggle, reveal.
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';
import { prefersReducedMotion } from './camst-counter.js';

gsap.registerPlugin(ScrollTrigger);

var accordionInstances = new WeakMap();
var themeTriggers = [];

function setEticaTheme(isRed) {
  document.body.classList.toggle('camst-etica-theme-red', isRed);
}

function bindAccordionItem(item) {
  var trigger = item.querySelector('[data-camst-accordion-trigger]');
  var panel = item.querySelector('[data-camst-accordion-panel]');

  if (!trigger || !panel) {
    return;
  }

  trigger.addEventListener('click', function () {
    var isOpen = item.classList.contains('is-open');

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    panel.hidden = isOpen;
  });
}

export function initCamstAccordionSection(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-accordion-section]'));
  } else if (scope.matches && scope.matches('[data-camst-accordion-section]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-accordion-section]'));
  }

  document.body.classList.add('camst-etica-page');

  roots.forEach(function (root) {
    if (root.dataset.camstAccordionSectionInit === '1') {
      return;
    }

    root.dataset.camstAccordionSectionInit = '1';
    initCamstReveal(root);

    Array.prototype.forEach.call(root.querySelectorAll('[data-camst-accordion-item]'), bindAccordionItem);

    if (prefersReducedMotion()) {
      return;
    }

    var ctx = gsap.context(function () {
      if (root.hasAttribute('data-camst-etica-theme-trigger')) {
        var themeTrigger = ScrollTrigger.create({
          trigger: root,
          start: 'top center',
          end: 'bottom center',
          onEnter: function () {
            setEticaTheme(true);
          },
          onLeave: function () {
            setEticaTheme(false);
          },
          onEnterBack: function () {
            setEticaTheme(true);
          },
          onLeaveBack: function () {
            setEticaTheme(false);
          },
        });

        themeTriggers.push(themeTrigger);
      }
    }, root);

    accordionInstances.set(root, ctx);
  });
}

export function teardownCamstAccordionSection(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-accordion-section]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-accordion-section]'));

  roots.forEach(function (root) {
    var ctx = accordionInstances.get(root);

    if (ctx) {
      ctx.revert();
      accordionInstances.delete(root);
    }

    teardownCamstReveal(root);
    delete root.dataset.camstAccordionSectionInit;
  });

  themeTriggers = themeTriggers.filter(function (trigger) {
    return trigger && !trigger.killed;
  });

  if (!document.querySelector('[data-camst-accordion-section]')) {
    document.body.classList.remove('camst-etica-page', 'camst-etica-theme-red');
  }
}

export function refreshCamstAccordionSection() {
  ScrollTrigger.refresh();
}
